import axios from "axios";
import { v4 } from "uuid";
export interface apiGetCalendarPricePostData {
  iniDate: string;
  endDate: string;
  hotelId: string;
  adults: number;
}

export interface apiGetCalendarPriceParams {
  serverPath: string;
  data: apiGetCalendarPricePostData;
}

export interface priceCalendarInfoListI {
  available: boolean;
  date: string;
  dayKey: string;
  parcial: boolean;
  stringDate: string;
  roomListAvailableIdList: string[];
  price?: string;
  priceValue?: number;
}

export interface apiGetCalendarPriceResponse {
  priceCalendarInfoByRoomTypeList: Array<{
    priceCalendarInfoList: Array<priceCalendarInfoListI>;
  }>;
  endDate: string;
  iniDate: string;
}

// axiosRetry(axios, {
//   retries: 3,
//   retryCondition: () => true,
// });

export const apiGetCalendarPrice = ({
  serverPath,
  data,
}: apiGetCalendarPriceParams) => {
  return axios.post<apiGetCalendarPriceResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/webcrossorigin/calendarprice`,
    {
      ...data,
      requestId: v4(),
    }
  );
};
